<i18n>
{
	"no": {
		"creationOfEdi" : "Opprettet",
		"transportMethod" : "Transportmetode",
		"messageFormat" : "Meldingsformat",
		"messageType" : "Meldingstype",
		"sender" : "Sender",
		"ssl" : "SSL",
		"receiver" : "Mottaker",
		"endpoint" : "Endepunkt",
		"path" : "Sti",
		"sentDate" : "Sendingsdato",
		"notSent" : "Denne meldingen er ikke sendt enda",
		"noOfOrders" : "Antall order",
		"orders": "Order ids",
		"sendingErrors" : "Feilmelding ved sending",
		"creatingErrors": "Feil ved generering av melding",
		"url": "Url til EDI fil",
		"guid": "GUID",
		"encoding": "Koding",
		"attempts" : "Sendings forsøk"

	},
	"en": {
		"creationOfEdi" : "Created",
		"transportMethod" : "Transportmethod",
		"messageFormat" : "Message format",
		"messageType" : "Message type",
		"sender" : "Sender",
		"ssl" : "SSL",
		"receiver" : "Recepient",
		"endpoint" : "Endpoint",
		"path" : "Path",
		"sentDate" : "Sending date",
		"notSent" : "This message is not sent",
		"noOfOrders" : "Number of orders",
		"orders": "Order ids",
		"sendingErrors" : "Error on sending",
		"creatingErrors": "Error on creation of message",
		"url": "Url to EDI file",
		"guid": "GUID",
		"encoding": "Encoding",
		"attempts" : "Sending attempts"
	}
}

</i18n>

<template>
	<div class="outbound-transmission-details">
		<EdiDetailProperty :header="$t('creationOfEdi')" :value="createDate" />
		<EdiDetailProperty :header="$t('sentDate')" :value="sentDate" />
		<EdiDetailProperty :header="$t('sender')" :value="getTransmissionDetails.setup.sender" />
		<EdiDetailProperty :header="$t('receiver')" :value="getTransmissionDetails.setup.recipient" />
		<EdiDetailProperty :header="$t('noOfOrders')" :value="noOfOrders" />
		<EdiDetailProperty :header="$t('messageType')" :value="getTransmissionDetails.setup.messageTypeDescription" />
		<EdiDetailProperty :header="$t('messageFormat')" :value="getTransmissionDetails.setup.messageFormatDescription" />
		<EdiDetailProperty :header="$t('endpoint')" :value="getTransmissionDetails.setup.endpoint" />
		<EdiDetailProperty :header="$t('path')" :value="getTransmissionDetails.setup.endpointPath" />
		<EdiDetailProperty :header="$t('transportMethod')" :value="getTransmissionDetails.setup.transportMethodDescription" />
		<EdiDetailProperty :header="$t('ssl')" :value="getTransmissionDetails.setup.ssl" />
		<EdiDetailProperty :header="$t('url')" :value="getTransmissionDetails.remoteEdiFileUrl" />
		<EdiDetailProperty :header="$t('guid')" :value="getTransmissionDetails.id" />
		<EdiDetailProperty :header="$t('encoding')" :value="getTransmissionDetails.encoding" />
		<EdiDetailProperty :header="$t('attempts')" :value="getTransmissionDetails.attempts" />
	</div>
</template>

<script>
import { mapGetters } from './store/outbound.store';
import EdiDetailProperty from '../common/EdiDetailProperty.vue';
import moment from 'moment';
export default {
	
	name: 'Details',

	components: { EdiDetailProperty },
	computed: {
		...mapGetters(['getTransmissionDetails']),

		createDate() {
			return this.formatToDate(this.getTransmissionDetails.created);
		},
		sentDate() {
			return this.formatToDate(this.getTransmissionDetails.sent);
		},
		noOfOrders() {
			if (Array.isArray(this.getTransmissionDetails.belongsToOrders))
				return this.getTransmissionDetails.belongsToOrders.length;
			return 1;
		}
	},

	methods:{
		formatToDate(dateObj) {
			if (!dateObj)
				return this.$t('notSent');
			if (dateObj.date)
				return moment(dateObj.date, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss');
			return this.$t('notSent');
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
.outbound-transmission-details{
	display:grid;
	grid-template-columns: repeat(2, minmax(max-content, 1fr));
	column-gap: 15px;
	row-gap: 15px;
}

</style>